import React, {ReactNode} from 'react';
import ReactMarkdown from 'react-markdown';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {oneDark} from 'react-syntax-highlighter/dist/esm/styles/prism'

import shadowClient from "../../lib/clients/shadow/shadowClient";
import {parseContent} from "./parseContent";

const MarkdownRenderer = ({markdown}: { markdown: string }) => {
    const users = shadowClient.userStore.users;
    return (
            <ReactMarkdown
                    // style={{width: "100%"}}
                    children={markdown}
                    className="markdown-body"
                    components={{
                        p: ({node, className, children, ...props}) => {
                            let nodes: ReactNode[];

                            if (!Array.isArray(children)) {
                                nodes = [children];
                            } else {
                                nodes = children
                            }

                            return <>{nodes.map(child => {
                                if (typeof child === "string") {
                                    return parseContent(child, users)
                                }
                                return child;
                            })}</>;

                        },
                        code({node, className, children, ref, ...rest}) {
                            const match = /language-(\w+)/.exec(className || '');
                            // @ts-ignore
                            return match ? (
                                    <SyntaxHighlighter
                                            {...rest}
                                            ref={ref as React.LegacyRef<SyntaxHighlighter>}
                                            // PreTag="div"
                                            children={String(children).replace(/\n$/, '')}
                                            language={match[1]}
                                            style={oneDark}
                                            onTouchStart={(event: React.TouchEvent) => {
                                                event.stopPropagation();
                                                return false;
                                            }}
                                            onTouchMove={(event: React.TouchEvent) => {
                                                event.stopPropagation();
                                                return false;
                                            }}
                                            onTouchEnd={(event: React.TouchEvent) => {
                                                event.stopPropagation();
                                                return false;
                                            }}
                                            // style={dark}
                                    />
                            ) : (
                                    <code style={{
                                        // width: '100%',
                                        // overflow: 'auto',
                                        // display: 'block',
                                    }}
                                          className={className} {...rest}>
                                        {children}
                                    </code>
                            );
                        },
                    }}
            />
    );
};

export default MarkdownRenderer;
